var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 11H8.33398C7.78086 11 7.33398 10.5531 7.33398 10V2C7.33398 1.44687 7.78086 1 8.33398 1H11.7121C11.8434 1 11.9715 1.05313 12.0652 1.14688L14.1871 3.26875C14.2809 3.3625 14.334 3.49063 14.334 3.62188V10C14.334 10.5531 13.8871 11 13.334 11ZM14.8934 2.55938L12.7746 0.440625C12.4934 0.159375 12.1121 0 11.7152 0H8.33398C7.23086 0 6.33398 0.896875 6.33398 2V10C6.33398 11.1031 7.23086 12 8.33398 12H13.334C14.4371 12 15.334 11.1031 15.334 10V3.62188C15.334 3.225 15.1746 2.84375 14.8934 2.5625V2.55938ZM3.33398 4C2.23086 4 1.33398 4.89687 1.33398 6V14C1.33398 15.1031 2.23086 16 3.33398 16H8.33398C9.43711 16 10.334 15.1031 10.334 14V13H9.33398V14C9.33398 14.5531 8.88711 15 8.33398 15H3.33398C2.78086 15 2.33398 14.5531 2.33398 14V6C2.33398 5.44688 2.78086 5 3.33398 5H5.33398V4H3.33398Z",
    fill: "#212737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.73ba7d81b9fda673656fdd7fdaf4f94a.svg";
export { ForwardRef as ReactComponent };